import { createContext } from 'react'

export const LiveblocksCopilotContext = createContext<string | null>(null)
